import HttpReference from '../platform/HttpReference';

export default class VehiclesFuel extends HttpReference {
  get() {
    return this.request();
  }
}
